/**
 * 404 Not Found Error
 */
export class NotFoundError extends Error {}
